/**
 * `badge_type` → emoji map for Portal leave-type pills.
 *
 * There is no emoji column on `portal_leave_types`; this is a display-only mapping
 * that mirrors the canonical `LEAVE_BADGE_TYPES` vocabulary. Typing the map as
 * `Record<LeaveBadgeType, string>` makes adding a future badge type without an
 * emoji a compile error. `getLeaveBadgeEmoji` falls back gracefully for any
 * unrecognized/legacy value.
 *
 * Lives in `common` so both the client (leave pills) and the server (Slack
 * time-away cards) can render the same emoji.
 */
import type { LeaveBadgeType } from '../types/portal-leave-types.js'

export const LEAVE_BADGE_EMOJI: Record<LeaveBadgeType, string> = {
    vacation: '🌴',
    sick: '🤒',
    child: '🧒',
    paternity: '👨‍🍼',
    maternity: '🤰',
    unpaid: '💸',
    study: '📚',
    training: '🎓',
    development: '🚀',
    health: '🩺',
    personal: '🙋',
    bereavement: '🕯️',
    care: '🤲',
    military: '🎖️',
    weekoff: '🛌',
    client_event: '🤝',
    internal_event: '🎉',
    remote: '🏠',
    other: '📋',
}

/** Emoji for a leave `badge_type`, with a neutral fallback for unknown values. */
export const getLeaveBadgeEmoji = (badgeType: string): string =>
    LEAVE_BADGE_EMOJI[badgeType as LeaveBadgeType] ?? '📋'
